import { FC } from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { usePageData } from '../../../core/PageData'

/**
 * Título da página no header. O header tem altura fixa (74px desktop / 55px mobile), então
 * cabem no máximo duas linhas: o título e UMA linha de apoio — a descrição
 * (<PageTitle description=...>) quando existir, senão os breadcrumbs.
 */
const DefaultTitle: FC = () => {
  const { pageTitle, pageDescription, pageBreadcrumbs } = usePageData()
  const hasBreadcrumbs = !!pageBreadcrumbs && pageBreadcrumbs.length > 0

  return (
    // minWidth 0: permite o truncamento (text-truncate) dentro do flex do header.
    <div
      className='page-title d-flex justify-content-center flex-column me-5 mw-100'
      style={{ minWidth: 0 }}
    >
      {/* begin::Title */}
      {pageTitle && <h1 className='text-dark fw-bolder fs-3 mb-0 text-truncate'>{pageTitle}</h1>}
      {/* end::Title */}

      {pageTitle && pageDescription ? (
        <p
          className='text-gray-700 fs-7 fw-semibold mb-0 pt-1 text-truncate'
          title={pageDescription}
        >
          {pageDescription}
        </p>
      ) : (
        hasBreadcrumbs && (
          <ul className='breadcrumb breadcrumb-separatorless fw-bold fs-7 pt-1'>
            {Array.from(pageBreadcrumbs).map((item, index) => (
              <li
                className={clsx('breadcrumb-item', {
                  'text-dark': !item.isSeparator && item.isActive,
                  'text-muted': !item.isSeparator && !item.isActive,
                })}
                key={`${item.path}${index}`}
              >
                {!item.isSeparator ? (
                  <Link className='text-muted text-hover-primary' to={item.path}>
                    {item.title}
                  </Link>
                ) : (
                  <span className='bullet bg-gray-300 w-5px h-2px'></span>
                )}
              </li>
            ))}
            <li className='breadcrumb-item text-dark'>{pageTitle}</li>
          </ul>
        )
      )}
    </div>
  )
}

export { DefaultTitle }
